import { useIdle } from '@vueuse/core'

export const useIdleLogout = () => {
  const config = useRuntimeConfig()
  const autenticacaoStore = useAutenticacaoStore()
  const store = useStore()

  // 30 minutos em milissegundos
  const IDLE_TIMEOUT = 30 * 60 * 1000

  const { idle } = useIdle(IDLE_TIMEOUT)

  const logout = async () => {
    try {
      // Chama o endpoint de logout no backend
      await useApiStore().request('/autenticacao/sair', {
        method: 'POST',
      })
    } catch (error) {
      console.error('Erro ao fazer logout no backend:', error)
    } finally {
      // Limpa os dados do frontend mesmo se o backend falhar
      performLogout()
    }
  }

  const performLogout = () => {
    // Reset dos stores seguindo o padrão do projeto
    store.$reset()
    useOrcamentoStore().$reset()
    useLivroDiarioAuxiliarStore().$reset()
    useAutenticacaoStore().$reset()
    useLarkStore().$reset()

    // Redireciona para a página de login
    window.location.href = config.public.loginUrl
  }

  // Observa quando o usuário fica inativo
  watch(idle, (isIdle) => {
    if (isIdle && autenticacaoStore.token) {
      // Limpa o token imediatamente para forçar logout
      autenticacaoStore.limparToken()

      // Exibe o modal de inatividade
      store.modalInatividade.exibir = true
    }
  })

  return {
    idle,
    logout,
    performLogout,
  }
}
